<template>
  <div class="box21-checkbox" @click.stop="changeHandler">
    <v-btn
      size="x-small"
      color="primary"
      :variant="outlined_when_unchecked && !isChecked ? 'outlined' : 'flat'"
      :title="editable ? 'Toggle' : 'Disabled'"
      :style="label ? 'margin-right: 10px;' : ''"
    >
      <v-icon size="x-small" v-if="isChecked">
        fas fa-check
      </v-icon>
      <input class="checkbox" style="cursor: pointer; display: none" type="checkbox" :checked="isChecked">
    </v-btn>
    <span v-if="label" class="box21-checkbox__label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    /** Vue 3 v-model */
    modelValue: { default: undefined },
    /** Vue 2 / explicit :value */
    value: { default: undefined },
    label: { default: '' },
    editable: { default: true },
    outlined_when_unchecked: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'toggled'],
  computed: {
    isChecked() {
      const raw = this.modelValue !== undefined ? this.modelValue : this.value;
      return raw === true || raw === 'true';
    },
  },
  methods: {
    changeHandler(event) {
      event.stopPropagation();
      if (!this.editable) {
        return;
      }
      const response = !this.isChecked;
      this.$emit('update:modelValue', response);
      this.$emit('toggled', response);
    },
  },
};
</script>

<style scoped>
.box21-checkbox {
  display: flex;
  align-items: center;
}

.box21-checkbox__label {
  margin-left: 8px;
}
</style>
